<!--
 * @Author: pengyong
 * @Date: 2020-11-15 10:14:01
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-01 23:25:04
 * @Description: 个人名片
 * @FilePath: /exhibit/src/views/user/businessCard.vue
-->
<template>
    <div class="businessCard-wrapper">
        <div class="section">
            <div class="title">{{ $t("userCenter").cardTitle }}</div>
            <div class="desc" v-if="userInfo.id">
                <p>{{ $t("userCenter").name }}：{{ userInfo.real_name || "" }}</p>
                <p>{{ $t("userCenter").account }}：{{ userInfo.phone || userInfo.email || "" }}</p>
                <!-- <p>{{ $t("userCenter").company }}：{{ userInfo.company || "" }}</p> -->
            </div>
        </div>
        <div class="section">
            <div class="title">{{ $t("userCenter").editCard }}</div>
            <div class="zhiwei">
                {{ $t("userInfo").gs }}*:
                <input type="text" v-model="company_name" :placeholder="$t('userCenter').inputPlaceholder" />
            </div>
            <div class="zhiwei">
                {{ $t("userCenter").zhiwei }}*:
                <input type="text" v-model="post" :placeholder="$t('userCenter').inputPlaceholder" />
            </div>
            <div class="upload-title">{{ $t("userCenter").elecCard }}:</div>
            <div class="upload">
                <img class="card-img" v-show="cardUrl" :src="cardUrl" alt="" />
                <img class="icon" v-show="!cardUrl" :src="require('@/assets/upload.png')" alt="" />
                <input type="file" accept="image/jpeg,image/jpg,image/png" @change="fileChange" ref="fileIpt" />
            </div>
            <div class="submit" @click="handleSubmit">{{ $t("userCenter").save }}</div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api";
export default {
    data() {
        return {
            cardUrl: "",
            post: "",
            company_name: ""
        };
    },
    computed: {
        ...mapState(["userInfo"])
    },
    mounted() {
        this.getMyCard();
    },
    methods: {
        handleSubmit() {
            api.setMyCard({
                id: this.id,
                params: {
                    post: this.post,
                    company_name: this.company_name,
                    card_img_id: this.card_img_id
                }
            }).then((res) => {
                if (res.res === 1) {
                    this.$message.success("保存成功");
                }
            });
        },
        getMyCard() {
            api.getMyCard().then((res) => {
                if (res.res === 1) {
                    this.id = res.card.id;
                    this.post = res.card.post;
                    this.company_name = res.card.company_name
                    this.cardUrl = res.card.card_image ? res.card.card_image.url : "";
                }
            });
        },
        fileChange(e) {
            var file = e.target.files[0]; //获取图片资源
            if (!file) return;
            var filename = file.name;
            // 只选择图片文件
            if (!/(png|jpg|jpeg)(\?.*)?$/.test(file.type)) {
                this.$message.error("只支持图片");
                this.$refs.fileIpt.value = "";
                return false;
            }
            // 生成预览图片
            const reader = new FileReader();
            reader.onload = (evt) => {
                const target = evt.target || evt.srcElement;
                this.cardUrl = target.result;
            };
            reader.readAsDataURL(file);
            // 上传文件
            const FILE = new FormData();
            FILE.append("file", file);
            api.uploadFile(FILE).then((res) => {
                if (res.res === 1) {
                    this.card_img_id = res.id;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.businessCard-wrapper {
    padding-top: 14px;
    font-size: 14px;
    .section {
        color: #5f7185;
        padding-top: 24px;
        .title {
            height: 16px;
            font-weight: 600;
            color: #09468c;
            line-height: 16px;
            letter-spacing: 1px;
            opacity: 0.45;
            position: relative;
            display: inline-block;
            margin-bottom: 11px;
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                height: 1px;
                width: 170px;
                background: #979797;
                right: -8px;
                transform: translateX(100%);
            }
        }
        .desc {
            color: #5f7185;
            line-height: 24px;
        }
        .zhiwei {
            display: flex;
            align-items: center;
            margin-bottom: 18px;
            color: #09468c;
            margin-top: 26px;
            font-weight: 500;
            input {
                width: 133px;
                height: 33px;
                background: rgba(9, 70, 140, 0.18);
                border-radius: 12px;
                line-height: 33px;
                font-size: 12px;
                padding: 0 13px;
                margin-left: 10px;
                color: #09468c;
                font-weight: 600;
                text-align: center;
            }
        }
        .upload-title {
            color: #09468c;
            font-weight: 500;
            margin-bottom: 15px;
        }
        .upload {
            width: 187px;
            height: 124px;
            border-radius: 13px;
            border: 2px dashed #e2e2e2;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
            .icon {
                width: 22px;
                height: 22px;
            }
            .card-img {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                z-index: 1;
                object-fit: cover;
            }
            input {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                cursor: pointer;
                opacity: 0;
                z-index: 9;
            }
        }
    }
    .submit {
        width: 96px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: #09468c;
        border-radius: 12px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
        margin-top: 32px;
        margin-bottom: 45px;
        margin-left: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/businessCard.vue